import React from 'react';
import { string, shape } from 'prop-types';
import Icon from 'components/icon';
import parse from 'html-react-parser';

export default function CourseListing({ item }) {
    return (
        <div className="c-course-listing">
            <div className="course-listing-wrapper">
                <div className="course-blurb">
                    <div className="course-media-wrapper">
                        <div className="ratio-wrapper">
                            <a href={item.url}>
                                <img src={item.thumbnail} alt={item.title} />
                            </a>
                        </div>
                    </div>
                    <div className="course-text-wrapper">
                        <h2><a href={item.url}>{item.title}</a></h2>
                        {item.paragraph ? parse(item.paragraph) : ''}

                        {item.tags &&
                        <div className="course-tag">
                            <Icon glyph="tag" />
                            {item.tags.map(tag => (
                                <a key={`${tag.title}`} href={tag.link}>{tag.title}</a>
                            ))}
                        </div> }
                    </div>
                </div>
                <div className="course-details">
                    <div className="course-list-details">
                        <span className="title">Next Session</span>
                        <span><Icon glyph="calendar" />{item.date}</span>
                        <span><Icon glyph="currency" />{item.price}</span>
                        <span><Icon glyph="time" />{item.duration}</span>
                    </div>
                    <div className="course-links">
                        <a href={item.register} className="btn-skin-1 btn-small" target="_blank">Register Now</a>
                        <a href={item.url} title={item.title} className="btn-skin-2 btn-small">Read More</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

CourseListing.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        title: string.isRequired,
        date: string,
        map: string,
        location: string,
        duration: string,
        price: string,
        thumbnail: string,
        register: string,
        paragraph: string
    }).isRequired
    /* eslint-enable react/no-typos */
};
